exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PLANREFUND .header[data-v-d6a2d1c2] {\n  display: flex;\n}\n.PLANREFUND .header span[data-v-d6a2d1c2] {\n  color: red;\n  margin: 5px;\n  font-size: 18px;\n}\n.PLANREFUND .foot[data-v-d6a2d1c2] {\n  display: flex;\n  margin-top: 5px;\n  flex-direction: row-reverse;\n}\n.PLANREFUND .foot .cancel-btn[data-v-d6a2d1c2] {\n  margin-left: 10px;\n}\n", ""]);

// exports
